// const firebase = require("../firebaseConfig.js");

const model = {
  type: "client",
  company: {
    name: null
  },
  name: {
    first: null,
    last: null
  },
  email: null,
  verified: false
};

const fields = [
  {
    path: "name.first",
    type: "text",
    label: "First name"
  },
  {
    path: "name.last",
    type: "text",
    label: "Last name"
  },
  {
    path: "company.name",
    type: "text",
    label: "Company name"
  },
  {
    path: "email",
    type: "text",
    label: "Email"
  },
  {
    path: "verified",
    type: "boolean",
    label: "Verified"
  }
];

const tableFields = [
  {
    key: "name",
    label: "Contact",
    sortable: true,
    formatter: (value, key, item) => {
      return item.name ? item.name.first + " " + item.name.last : "——";
    }
  },
  {
    key: "company.name",
    label: "Company",
    sortable: true
  },
  {
    key: "verified",
    label: "Verified",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: true,
    formatter: value => {
      return value ? "Yes" : "No";
    }
  }
];

const info = {
  id: "clients",
  db: "users",
  name: "Clients",
  single: "Client",
  fields: tableFields
};

export {model, fields, tableFields, info};
